import { tabRegistry } from "../tab-registry"
import type { ViewManifest } from "../views/manifest"

// Each view page calls this on load to announce itself in the tab registry.
// Without it, the launcher can't see this tab as a peer (its open-indicator
// stays empty) and openOrFocus from other tabs can't re-focus this window.
export function joinAsView(view: ViewManifest): void {
  // Set window.name so openOrFocus's window.open("", target) trick can
  // re-focus this tab from another tab without re-navigating.
  window.name = view.target
  void tabRegistry.join(view.target, view.href)
  tabRegistry.addEventListener("duplicate-self", () => {
    window.close()
  })
}
